import { ValueOf } from "src/types.d"

export const PickerViewType = Object.freeze({
  Date: "Date",
  Time: "Time",
  DateTime: "DateTime",
} as const)

export type PickerViewType = ValueOf<typeof PickerViewType>
